'use client';
import { User } from '@/common/model/apiClient/User';
import { useConfigStore } from '@/providers/ConfigStoreProvider';
import { StorageKey } from '@common/application/enums/StorageKey';
import { useQuery } from '@tanstack/react-query';
import { SelectBox } from 'devextreme-react';
import { useSession } from 'next-auth/react';
import { useIntl } from 'react-intl';
import { useSessionStorage } from 'usehooks-ts';

interface CompanySelectProps {}

function CompanySelect(props: CompanySelectProps) {
  const { data: session } = useSession();
  const intl = useIntl();
  const { company, setCompany } = useConfigStore((s) => s);
  const [sessionCompany, setSessionCompany] = useSessionStorage(StorageKey.COMPANY, '');

  const userCompanies = useQuery({
    queryKey: ['user_companies'],
    queryFn: () => User.getCompanies(session!.user?.userId),
    enabled: !!session?.user?.userId,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    retry: 1,
    placeholderData: (previousData) => previousData,
  });

  const onValueChange = (e: string) => {
    if (!e) return;
    setSessionCompany(e);
    setCompany(Number(e));
  };

  return (
    <SelectBox
      label={intl.formatMessage({ defaultMessage: 'Select Company' })}
      dataSource={userCompanies.data?.payload.map((c) => c.company) ?? []}
      displayExpr={'name'}
      valueExpr={'id'}
      // itemRender={CurrencyRender}
      value={company}
      onValueChange={onValueChange}
    />
  );
}

export default CompanySelect;
